'use client';

import styled from 'styled-components';
import { typography } from '@/styles/helpers';

export const ScNotAuthCard = styled.div`
  position: relative;
  width: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  gap: 24px;
`;

export const ScNotAuthTitleRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  h1 {
    flex: 1;
    text-align: center;
    ${typography.headline3mobile}
    color: ${({ theme }) => theme.whiteColor};
    margin: 0;
  }

  .back {
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    color: ${({ theme }) => theme.whiteColor};
    transform: rotate(180deg);
  }

  .spacer {
    width: 24px;
    flex-shrink: 0;
  }
`;

export const ScNotAuthCover = styled.div`
  position: relative;
  width: 180px;
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
`;

export const ScNotAuthButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  & .demo-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    ${typography.headline4};
    text-transform: uppercase;
    height: 40px;
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    cursor: pointer;
  }

  button {
    width: 280px;
    max-width: 100%;
    height: 48px;
    padding: 0;
  }

  button:nth-child(2) {
    width: 180px;
    height: 40px;
  }
`;
